<template src="../templates/notAuthorized.html"></template>
<script>

    export default {
        name: 'NotAuthorized',
        mounted(){
            Event.$emit("rebuildMenu");
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/NotAuthorized.vue